import css from './sass/auctions.module.scss'

export default function AuctionDisclosureFooter( {auctionDetail} ) {

  //auctionDetail available here if language needs adapting for endowment funds
  const fundText = auctionDetail?.FundName ? auctionDetail.FundName : '[Fund Name]'

  return (
    <p className={css['auction-description-footer']}>

      <br />
      <b>FUND DISCLOSURE:</b>
      <br />
      All payments/donations from this auction will be added to the {fundText} subject to the terms and conditions of that fund.
      <br />
      <br />
      <b>MAILING REMINDER:</b>
      <br />
      Winning bidder incurs all costs for shipping and handling.
      <br />
      Large and heavy items cannot be mailed.
      <br />
      Happy browsing and bidding! Thanks!
    </p>
  )
}